import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { Users, FileText, FilePlus, FileMinus, FolderOpen, Receipt, Car, CreditCard, ChevronRight, Database,
  Archive, DoorOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../Style/Member.css";
import "../Style/FinancialTables.css";
import "../Style/Dashboard.css";

const HistroyDeleteRecord = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const historyCards = [
    {
      id: 1,
      title: "Deleted Members",
      count: "View Records",
      icon: <Users size={20} />,
      path: "/member-history",
      color: "#ef4444",
      gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      bgColor: "#fef2f2",
    },
    {
      id: 2,
      title: "Deleted Bills",
      count: "View Records",
      icon: <FileText size={20} />,
      path: "/histroy-deleted-bill",
      color: "#3b82f6",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
      bgColor: "#eff6ff",
    },
    {
      id: 3,
      title: "Deleted Credit Notes",
      count: "View Records",
      icon: <FilePlus size={20} />,
      path: "/credit-note-history",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      bgColor: "#f0fdf4",
    },
    {
      id: 4,
      title: "Deleted Debit Notes",
      count: "View Records",
      icon: <FileMinus size={20} />,
      path: "/debit-note-history",
      color: "#f97316",
      gradient: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
      bgColor: "#fff7ed",
    },
    {
      id: 5,
      title: "Deleted Opening Balances",
      count: "View Records",
      icon: <FolderOpen size={20} />,
      path: "/histroy-opening",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      bgColor: "#f5f3ff",
    },
    {
      id: 6,
      title: "Deleted Receipts",
      count: "View Records",
      icon: <Receipt size={20} />,
      path: "/histroy-receipt",
      color: "#6366f1",
      gradient: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
      bgColor: "#eef2ff",
    },
    {
      id: 7,
      title: "Deleted Parking",
      count: "View Records",
      icon: <Car size={20} />,
      path: "/histroy-parking",
      color: "#06b6d4",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
      bgColor: "#ecfeff",
    },
    {
      id: 8,
      title: "Deleted Advance Payments",
      count: "View Records",
      icon: <CreditCard size={20} />,
      path: "/histroy-deleted-advance",
      color: "#14b8a6",
      gradient: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
      bgColor: "#f0fdfa",
    },
    {
      id: 9,
      title: "Deleted Visitors",
      count: "View Records",
      icon: <DoorOpen size={20} />,
      path: "/visitor-deleted-list",
      color: "#0ea5e9",
      gradient: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
      bgColor: "#f0f9ff",
    },
  ];

  return (
    <div className="app-container">
      <style>
        {`
        /* ========== RECEIPT PAGE OPTIMIZATIONS ========== */
        .app-container {
          height: 100vh;
          overflow: hidden !important;
        }

        .main-layout {
          height: calc(100vh - 64px);
          overflow: hidden !important;
        }

        .content-area {
          height: 100%;
          overflow-y: auto !important;
          overflow-x: hidden;
          padding-bottom: 20px;
          background: #f8fafc;
        }

        .financial-container,
        .financial-card {
          height: auto !important;
          overflow: visible !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .financial-body {
          height: auto !important;
          overflow: visible !important;
          padding: 0 !important;
        }

        /* ========== COMPACT DASHBOARD HEADER ========== */
        .dashboard-header {
          background: linear-gradient(135deg, #0d6efd 0%, #0b5ed7 100%);
          padding: 16px 24px;
          border-radius: 8px 8px 0 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: white;
          margin-bottom: 0;
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .header-icon-wrapper {
          width: 36px;
          height: 36px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header-title h2 {
          font-size: 16px;
          font-weight: 600;
          margin: 0;
          color: white;
        }

        .header-title p {
          font-size: 11px;
          opacity: 0.9;
          margin: 2px 0 0 0;
          color: rgba(255, 255, 255, 0.9);
        }

        .header-stats {
          display: flex;
          gap: 20px;
        }

        .stat-item {
          text-align: center;
        }

        .stat-number {
          font-size: 14px;
          font-weight: 700;
          color: white;
          display: block;
        }

        .stat-label {
          font-size: 10px;
          opacity: 0.9;
          color: rgba(255, 255, 255, 0.9);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* ========== COMPACT CARDS GRID ========== */
        .cards-grid-container {
          background: white;
          border-radius: 0 0 8px 8px;
          padding: 16px;
          border: 1px solid #e2e8f0;
          border-top: none;
        }

        .compact-cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 12px;
          margin: 0;
          padding: "15px";
          height: "auto";
        }

        /* Compact Card Design */
        .compact-card {
          background: white;
          border-radius: 8px;
          padding: 16px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: 1px solid #e2e8f0;
          position: relative;
          overflow: hidden;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .compact-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          border-color: transparent;
        }

        .compact-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: var(--card-gradient);
        }

        .card-top-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 8px;
        }

        .compact-icon-wrapper {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--card-bg);
        }

        .compact-icon {
          color: var(--card-color);
        }

        .card-arrow {
          opacity: 0;
          transform: translateX(-5px);
          transition: all 0.2s ease;
          color: #64748b;
        }

        .compact-card:hover .card-arrow {
          opacity: 1;
          transform: translateX(0);
        }

        .card-content h4 {
          font-size: 13px;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 4px 0;
          line-height: 1.2;
        }

        .card-content p {
          font-size: 10px;
          color: #64748b;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 4px;
          font-weight: 500;
        }

        /* Back Button - Compact */
        .back-button-container {
          margin-bottom: 16px;
        }

        .compact-back-button {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          color: #475569;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          text-decoration: none;
        }

        .compact-back-button:hover {
          background: #f8fafc;
          border-color: #cbd5e0;
        }

        /* Dashboard Info Section */
        .dashboard-info {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 16px;
          margin-top: 16px;
        }

        .info-header {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
          padding-bottom: 10px;
          border-bottom: 1px solid #f1f5f9;
        }

        .info-icon {
          width: 20px;
          height: 20px;
          color: #0d6efd;
        }

        .info-title {
          font-size: 13px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }

        .info-content {
          font-size: 11px;
          color: #64748b;
          line-height: 1.5;
          margin: 0;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .compact-cards-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .compact-cards-grid {
            grid-template-columns: 1fr;
          }
          
          .dashboard-header {
            flex-direction: column;
            gap: 12px;
            text-align: center;
            padding: 12px 16px;
          }
          
          .header-left {
            flex-direction: column;
            text-align: center;
          }
          
          .header-stats {
            width: 100%;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .cards-grid-container {
            padding: 12px;
          }
          
          .header-stats {
            flex-wrap: wrap;
            gap: 12px;
          }
          
          .stat-item {
            flex: 1 0 calc(50% - 12px);
          }
        }
        `}
      </style>
      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="content-area">
          <SubHeader />

          <div className="financial-container">
            <div className="financial-card">
              <div className="cards-grid-container">
                <div className="compact-cards-grid">
                  {historyCards.map((card) => (
                    <div key={card.id}
                      className="compact-card"
                      onClick={() => navigate(card.path)}
                      onMouseEnter={() => setHoveredCard(card.id)}
                      onMouseLeave={() => setHoveredCard(null)}
                      style={{
                        "--card-gradient": card.gradient,
                        "--card-bg": card.bgColor,
                        "--card-color": card.color,
                      }}
                    >
                      <div className="card-top-row">
                        <div className="compact-icon-wrapper">
                          <div className="compact-icon">{card.icon}</div>
                        </div>
                        <div className="card-arrow">
                          <ChevronRight size={16} />
                        </div>
                      </div>
                      <div className="card-content">
                        <h4>{card.title}</h4>
                        <p>
                          <Database size={12} />
                          {card.count}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HistroyDeleteRecord;
